import { useState } from "react";
import Draggable from "react-draggable";
import { Box } from "@chakra-ui/layout";
import { useTranslation } from "react-i18next";
import useCheckLogin from "../../../hook/useCheckLogin";
import { useNavigate, useParams } from "react-router-dom";
import UseGetGameBoxBackPathV2 from "../../../hook/useGetGameBoxBackPath_v2";
import { useSelector } from "react-redux";
import ToggleFavorite from "../../../components/Favorite/ToggleFavorite";
import useGames from "../useGames";

const PCToolTab = ({ hiddenHeader, setHiddenHeader }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const [dragStartTime, setDragStartTime] = useState(0);
  const { isMachineUser } = useCheckLogin();

  const navigate = useNavigate();
  const getPrevPath = UseGetGameBoxBackPathV2();
  const { to } = useParams();
  const gameConfig = useSelector((state) => state.isGameConfig);
  const { SubPlatformEnum } = gameConfig || {};

  const { handleExitGame } = useGames();

  const handleStart = () => {
    setDragStartTime(Date.now());
  };

  const handleStop = () => {
    if (Date.now() - dragStartTime < 200) {
      handleExitGame();
    }
  };

  const onLeaveGameBox = () => {
    handleExitGame();
  };

  return (
    hiddenHeader && (
      <Draggable onStart={handleStart} onStop={handleStop}>
        <Box
          position={"absolute"}
          bgImage={`linear(to-b,#AD8D70,#E3D4BA,#7C6150)`}
          bgPosition="center"
          bgRepeat="no-repeat"
          bgSize="100%100%"
          left={"0px"}
          top={"0px"}
          zIndex={999999}
          display="flex"
          alignItems={"center"}
          gap={2}
          borderRadius={5}
          px={2}
        >
          <Box
            minW={"48px"}
            h={"52px"}
            gap={"10px"}
            alignItems={"center"}
            justifyContent={"center"}
            cursor="pointer"
            className={`!flex`}
            zIndex={999999}
            onClick={onLeaveGameBox}
            sx={{
              "& > *": {
                color: "text-yellow-500",
              },
            }}
          >
            {i18n("leave")}
          </Box>
          {!isMachineUser && <ToggleFavorite />}
        </Box>
      </Draggable>
    )
  );
};

export default PCToolTab;
